import React from 'react';
import PropTypes from 'prop-types';
import { PLACEHOLDER_COLOR } from '../../../styles/variables';

const CloseIcon = ({ color, size }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 17 17">
      <path
        fill={color || PLACEHOLDER_COLOR}
        d="M10.282 8.9l3.567 3.567a.977.977 0 1 1-1.382 1.382l-3.568-3.567-3.567 3.567a.977.977 0 1 1-1.382-1.382l3.567-3.568L3.95 5.332A.977.977 0 0 1 5.332 3.95l3.567 3.567 3.568-3.567a.977.977 0 0 1 1.382 1.382l-3.567 3.567z"
      />
    </svg>
  );
};

CloseIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

CloseIcon.defaultProps = {
  color: PLACEHOLDER_COLOR,
  size: '17px',
};

export default CloseIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/Close/index.js